import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {getItemType} from '../../../helpers/common';

import './blCategoryItem.scss';

const BlCategoryItem = ({
                          addBlItem,
                          blCategory,
                          blCategoryItem,
                          selectedBusinessLunch,
                          selectedItems,
                          menuItemTypes,                          
                        }) => {
  const [supplements, setSupplements] = useState([]);
  const [instructions, setInstructions] = useState([]);

  const selectedOrderItem = selectedItems.find(i => i.menuItem.menu_item_id === blCategoryItem.menu_item_id && i.orderItem.business_category_id === blCategory.menu_item_id);
  const relation = selectedBusinessLunch.relations.find(r => r.category_item_id === blCategory.menu_item_id && r.menu_item_id === blCategoryItem.menu_item_id);
  const isSelected = selectedItems.some(i => i.menuItem.menu_item_id === blCategoryItem.menu_item_id && i.orderItem.business_category_id === blCategory.menu_item_id);
  const editable = selectedOrderItem && !selectedOrderItem.noAdditions;

  useEffect(() => {
    if (!selectedBusinessLunch || !selectedBusinessLunch.relations || selectedBusinessLunch.relations.length === 0) {
      return;
    }

    const supplementsIds = selectedBusinessLunch.relations
      .filter(r => r.menu_item_id === blCategoryItem.menu_item_id && r.supplement_item_id !== null)
      .map(r => r.supplement_item_id);

    const additions = selectedBusinessLunch.menuItems
      .filter(mi => supplementsIds.includes(mi.menu_item_id))
      .map(i => Object.assign({}, i, {menuItemType: getItemType(i, menuItemTypes)}));

    setSupplements(additions);
    // setSupplements(additions.filter(i => i.menuItemType === 'SUPPLEMENT'));
    // setInstructions(additions.filter(i => i.menuItemType === 'PREPARATION_INSTRUCTION'));
  }, [blCategoryItem]);

  return (
    <div
      className={ `bl-category-item ${isSelected ? 'selected' : ''}` }
      onClick={ () => {
        addBlItem(blCategoryItem);
      } }>
      {isSelected && editable && (
        <div className="pencil-icon">
          <FontAwesomeIcon icon="pencil-alt" />
        </div>
      )}

      {blCategoryItem.item_name}
    </div>
  );
};

export default BlCategoryItem;
